'use es6';

const ONE_DAY = 1000 * 60 * 60 * 24;
/**
 * Period after which item will be removed.
 *
 * @type {UInt}
 */

export const CACHE_EXPIRATION_PERIOD = 10 * ONE_DAY;
/**
 * Max items to retain data for.
 *
 * @type {UInt}
 */

export const CACHE_MAX_ITEMS = 25;